const links = {
  logo: "https://padmin.com",
  contactUs: "https://padmin.com/contact/",
  privacyPolicy: "https://padmin.com/about-us/privacy-policy/",
};

export default links;
